import React from "react";
import Layout from "../Dashboard/Layout";
import Customers from "../Dashboard/Customers";

const CustomerList = () => {
  return (
    <Layout>
      <Customers />
    </Layout>
  );
};

export default CustomerList;
